export const VERSAO_PESQUISA_COMPLETA = 1;
export const VERSAO_PESQUISA_PAGINADA = 2;